export default __webpack_public_path__ + "images/la-8d6ad26b7061bc0588921e7a978bdac1.svg";